import React, { Fragment, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountClientContactAsync, updateAccountClientContactAsync, resetSelectedRecordObjectInState } from "./ClientContactSlice";
import { ClientContactInitialsForAdd, ClientContactInitialsForUpdate } from "./interfaces/ClientContactClass";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import clsx from "clsx";
import { dropDownSelectionStyles , getValueFromResource} from '../../../common/timeLiveFunction';
import * as Sentry from "@sentry/react";

export const ClientContactForm = (props: any) => {
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const { AccountPartyId, t } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ClientContactInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.clientContact);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [selectedCountryOptionDropDown, setSelectedCountryOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [selectedDepartmentOptionDropDown, setSelectedDepartmentOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [statusTypeArray, SetstatusTypeArray] = useState<any | ''>([]);
    const [departmentArray, setDepartmentArray] = useState<any | ''>([]);
    const [countryArray, SetCountryArray] = useState<any | ''>([]);
    const [tab, setTab] = useState('Basic');
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const formikRef = useRef<any>(null);
    const getCountriesAsync = async () => {
        const response = await fetchAPI("api/v2/ClientContacts/Countries", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        if (Object.keys(json.Data).length !== 0) {
            json.Data.map((item: any) => {
                item.value = item.CountryId;
                item.label = item.Country;
                delete item.CountryId;
                delete item.Country;
            });
            SetCountryArray(json.Data);
        }
    }

    const getClientDepartmentAsync = async () => {
        const response = await fetchAPI("api/v2/ClientContacts/Departments/" + AccountPartyId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        if (Object.keys(json.Data).length !== 0) {
            json.Data.map((item: any) => {
                item.value = item.Id;
                item.label = item.Name;
                delete item.Id;
                delete item.Name;
            });
            setDepartmentArray(json.Data);
        }

    }

    useEffect(() => {
        getCountriesAsync();
        getClientDepartmentAsync();
    }, [])

    useEffect(() => {
        let stateItem: any = {}
        setTab('Basic')
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ClientContactInitialsForUpdate).map((item) => {
                if (item === 'AccountPartyId') {
                    return stateItem[item] = AccountPartyId;
                }
                else {
                    return stateItem[item] = tempObj[item];
                }
            })
            setCurrentFieldsData(stateItem);
            setSelectedCountryOptionDropDown(countryArray.find((country: any) => country.value == stateItem.CountryId));
            setSelectedDepartmentOptionDropDown(departmentArray.find((department: any) => department.value == stateItem.AccountPartyDepartmentId));

        }
        else {

            setCurrentFieldsData({ ...ClientContactInitialsForAdd, "AccountPartyId": AccountPartyId });
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountClientContactAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Client Contact Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                }).catch((rejectedValueOrSerializedError) => {
                     Sentry.captureException(rejectedValueOrSerializedError);
                })
        }
        else {

            dispatch(addAccountClientContactAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Client Contact Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                }).catch((rejectedValueOrSerializedError) => {
                     Sentry.captureException(rejectedValueOrSerializedError);
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    return (
        <>
            <Formik
             innerRef={formikRef}
                initialValues={{
                    ...currentFieldsData,
                    AccountExpenseTypeId: selectedOptionDropDown?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}

                validationSchema={yup.object().shape({
                    FirstName: yup
                        .string()
                        .label('FirstName')
                        .trim()
                        .required(getValueFromResource('First Name is required', dispatch, t)),
                    LastName: yup
                        .string()
                        .label('LastName')
                        .trim()
                        .required(getValueFromResource('Last Name is required', dispatch, t))

                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className='card-body py-1' style={{ overflowY: 'auto' }}>
                        <div className='card-header' style={{ marginLeft: '-30px' }}>
                            <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-4' role='tablist'>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Basic' })}
                                        onClick={() => setTab('Basic')}
                                        role='tab'
                                    >
                                        {/* {t('Basic')} */}
                                        {getValueFromResource('Basic',dispatch, t)}
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Details' })}
                                        onClick={() => setTab('Details')}
                                        role='tab'
                                    >
                                        {/* {t('Details')} */}
                                        {getValueFromResource('Details',dispatch, t)}
                                    </a>
                                </li>
                            </ul>
                            </div>
                            <div className='tab-content pt-6'>
                                <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('First Name')} */}
                                                {getValueFromResource('First Name',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='FirstName'
                                                name='FirstName'
                                                value={values.FirstName}
                                                onChange={handleChange('FirstName')}
                                                ref={defaultFocusRef}
                                                // onBlur={() => setFieldTouched('FirstName')}
                                            />
                                            <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                {touched.FirstName && errors.FirstName &&
                                                    <p className='errorMsg'>{errors.FirstName as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Last Name')} */}
                                                {getValueFromResource('Last Name',dispatch, t)}
                                                </label>
                                            <input type="text"
                                              className="form-control fs-7 fw-normal"
                                                id='LastName'
                                                name='LastName'
                                                value={values.LastName}
                                                onChange={handleChange('LastName')}
                                                onBlur={() => setFieldTouched('LastName')}
                                            />
                                            <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                {touched.LastName && errors.LastName &&
                                                    <p className='errorMsg'>{errors.LastName as string}</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-4'>
                                       
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Email')} */}
                                                {getValueFromResource('Email',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='EMailAddress'
                                                name='EMailAddress'
                                                value={values.EMailAddress}
                                                onChange={handleChange('EMailAddress')}
                                                onBlur={() => setFieldTouched('EMailAddress')}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Country')} */}
                                                {getValueFromResource('Country',dispatch, t)}
                                                </label>
                                            <Select
                                                value={countryArray.find((option: any) => option.value == values.CountryId)}
                                                 className="basic-single fs-7 fw-normal"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="CountryId"
                                                onBlur={() => setFieldTouched('CountryId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "CountryId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                options={countryArray}
                                                styles={dropDownSelectionStyles}
                                            />
                                        </div>
                                    </div>
                                    <div className='row mt-4'>                                       
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Department')} */}
                                                {getValueFromResource('Department',dispatch, t)}
                                                </label>
                                            <Select
                                                value={departmentArray.find((option: any) => option.value == values.AccountPartyDepartmentId)}
                                                className="basic-single fs-7 fw-normal"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="AccountPartyDepartmentId"
                                                onBlur={() => setFieldTouched('AccountPartyDepartmentId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "AccountPartyDepartmentId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                options={departmentArray}
                                                styles={dropDownSelectionStyles}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Location Contact')} */}
                                                {getValueFromResource('Location Contact',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='Location'
                                                name="Location"
                                                value={values.Location}
                                                onChange={handleChange('Location')}
                                                onBlur={() => setFieldTouched('Location')}
                                            />
                                        </div>
                                    </div>                                    
                                </div>

                                <div className={clsx('tab-pane', { active: tab === 'Details' })}>
                                    <div className='row'>
                                    <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Address1')} */}
                                                {getValueFromResource('Address1',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='Address1'
                                                name="Address1"
                                                value={values.Address1}
                                                onChange={handleChange('Address1')}
                                                onBlur={() => setFieldTouched('Address1')}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Address2')} */}
                                                {getValueFromResource('Address2',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                 className="form-control fs-7 fw-normal"
                                                id='Address2'
                                                name="Address2"
                                                value={values.Address2}
                                                onChange={handleChange('Address2')}
                                                onBlur={() => setFieldTouched('Address2')}
                                            />
                                        </div>

                                        </div>
                                        <div className='row mt-4'>  
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('State')} */}
                                                {getValueFromResource('State',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='State'
                                                name="State"
                                                value={values.State}
                                                onChange={handleChange('State')}
                                                onBlur={() => setFieldTouched('State')}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('City')} */}
                                                {getValueFromResource('City',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                 className="form-control fs-7 fw-normal"
                                                id='City'
                                                name="City"
                                                value={values.City}
                                                onChange={handleChange('City')}
                                                onBlur={() => setFieldTouched('City')}
                                            />
                                        </div>
                                        </div>
                                        <div className='row mt-4'>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Telephone1')} */}
                                                {/* {getValueFromResource('Telephone1',dispatch, t)} */}
                                                {getValueFromResource('Phone1',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='Telephone1'
                                                name="Telephone1"
                                                value={values.Telephone1}
                                                onChange={handleChange('Telephone1')}
                                                onBlur={() => setFieldTouched('Telephone1')}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Telephone2')} */}
                                                {/* {getValueFromResource('Telephone2',dispatch, t)} */}
                                                 {getValueFromResource('Phone2',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='Telephone2'
                                                name="Telephone2"
                                                value={values.Telephone2}
                                                onChange={handleChange('Telephone2')}
                                                onBlur={() => setFieldTouched('Telephone2')}
                                            />
                                        </div>
                                        </div>
                                        <div className='row mt-4'>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Fax')} */}
                                                {getValueFromResource('Fax',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='Fax'
                                                name="Fax"
                                                value={values.Fax}
                                                onChange={handleChange('Fax')}
                                                onBlur={() => setFieldTouched('Fax')}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Zip Code')} */}
                                                {getValueFromResource('Zip Code',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='Zip'
                                                name="Zip"
                                                value={values.Zip}
                                                onChange={handleChange('Zip')}
                                                onBlur={() => setFieldTouched('Zip')}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-end'>
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                    onClick={handleCloseOnClickEvent}
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel',dispatch, t)}
                                </button>

                                <button
                                    type="button"
                                     className="btn btn-sm btn-primary"
                                    onClick={() => handleSubmit()} disabled={!isValid}
                                    data-kt-element='send'
                                >
                                    {/* {t('Save')}  */}
                                    {getValueFromResource('Save',dispatch, t)}
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
